import { Button, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FIELDS, RECURRENCE_TYPE_VALUES } from '../constants';
import { getTransportLabelSx } from './transportTypographySx';
import RecurrenceDialog from './RecurrenceDialog';
import YesNoToggle from './YesNoToggle';
import { getRecurrenceSummary } from './utils';

RecurrenceRules.propTypes = {
  formState: PropTypes.object.isRequired,
  setFields: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isNewRequest: PropTypes.bool,
  showToggle: PropTypes.bool,
  detailsMode: PropTypes.bool,
};

export default function RecurrenceRules({
  formState,
  setFields,
  disabled = false,
  isNewRequest = true,
  showToggle = true,
  detailsMode = false,
}) {
  const [recurrenceDialogOpen, setRecurrenceDialogOpen] = useState(false);

  return (
    <>
      <Grid container spacing={2} alignItems="center">
        {showToggle ? (
          <Grid item>
            <YesNoToggle
              title={isNewRequest ? 'Create Recurring Trip?' : 'Recurring:'}
              setter={(value) => setFields({ [FIELDS.IS_RECURRING]: value })}
              value={formState.IsRecurring}
              disabled={disabled}
              detailsMode={detailsMode}
            />
          </Grid>
        ) : (
          <Grid item>
            <Typography color="text.secondary" sx={{ ...getTransportLabelSx(detailsMode), mr: 1 }}>
              Recurring:
            </Typography>
          </Grid>
        )}
        {formState.IsRecurring && (
          <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => setRecurrenceDialogOpen(true)}
              sx={{ color: '#707070', borderColor: '#E5E1E1', fontWeight: 400, fontSize: '14px' }}
              disabled={disabled}
            >
              {formState.RecurrenceType && formState.RecurrenceFrequency
                ? getRecurrenceSummary(
                    formState.IsRecurring,
                    formState.RecurrenceType,
                    formState.RecurrenceFrequency,
                    formState.RecurrenceDayOfMonth,
                    formState.RecurrenceEndDate,
                    RECURRENCE_TYPE_VALUES,
                    formState.RecurrenceDayOfWeek,
                    formState.RecurrenceWeekOfMonth
                  )
                : 'Set recurring dates or schedule'}
            </Button>
          </Grid>
        )}
      </Grid>
      <RecurrenceDialog
        open={recurrenceDialogOpen}
        onCancel={() => setRecurrenceDialogOpen(false)}
        onSave={() => setRecurrenceDialogOpen(false)}
        formState={formState}
        setFields={setFields}
      />
    </>
  );
}
